import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusToast, StatusToastVariant } from '@this+that/ui';

import { useCustomToast } from './useCustomToast';
import { useMessageDialogStore } from '../store';
import { MISSING_SNAPSHOT_TOAST_DURATION_MS } from '../utils/constants/drafts';

export const useMissingSnapshotNotice = (): void => {
  const { t } = useTranslation();
  const { customToaster } = useCustomToast();
  const showToastRef = useRef(customToaster);
  showToastRef.current = customToaster;
  const translateRef = useRef(t);
  translateRef.current = t;
  const noticeCount = useMessageDialogStore(
    (state) => state.missingSnapshotNoticeCount,
  );
  const shownCountRef = useRef(noticeCount);

  useEffect(() => {
    const previousCount = shownCountRef.current;
    shownCountRef.current = noticeCount;
    if (noticeCount <= previousCount) {
      return;
    }
    showToastRef.current(
      <StatusToast
        status={StatusToastVariant.Warning}
        message={translateRef.current(
          'inbox.userCommunication.actions.localDraftGone',
        )}
        durationMs={MISSING_SNAPSHOT_TOAST_DURATION_MS}
        dataTestId="missing-snapshot-toast"
      />,
      undefined,
      MISSING_SNAPSHOT_TOAST_DURATION_MS,
    );
  }, [noticeCount]);
};
